import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useEmailSend = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { password, email, token } = state ?? {};

  useEffect(() => {
    if (!email || !token) return navigateToPage(PageRoutes.LOGIN);
  }, [email, token, navigateToPage]);

  const maskedEmail = useMemo(() => {
    if (!email) return "";
    const [localPart, domain] = email.split("@");
    if (!domain) return email;
    const maskedLocal =
      localPart.length > 2
        ? `${localPart.slice(0, 2)}${"*".repeat(localPart.length - 2)}`
        : "*".repeat(localPart.length);
    return `${maskedLocal}@${domain}`;
  }, [email]);

  const handleEmailSend = useCallback(() => {
    dispatch(appActions.showLoading());

    dispatch(
      authActions.sendOtpToEmail.started({
        session_token: token,
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: (data) => {
          if (data.success) {
            navigateToPage(PageRoutes.EMAIL_SEND_COMPLETE, false, {
              password,
              email,
              token,
            });
          }
        },
      }),
    );
  }, [dispatch, email, navigateToPage, password, token]);

  return {
    maskedEmail,
    handleEmailSend,
  };
};
